import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ViewTableComponent } from '../../base/view-table/view-table.component';
import { PageEvent } from '@angular/material/paginator';
import { HttpParameter } from 'src/app/types/http-parameter';

@Component({
  selector: 'app-enrollment-tracking',
  templateUrl: './enrollment-tracking.component.html',
  styleUrls: ['./enrollment-tracking.component.css']
})
export class EnrollmentTrackingComponent extends ViewTableComponent implements OnInit {

  currentPage: number;

  override displayedColumns: string[] = [
    'field_sale_date',
    'title_student_account',
    'field_student_department',
    'title_enrollment',
    'field_total_lessons_remaining',
    'field_total_lessons_paid_ahead',
    'field_first_name_teacher',
    'field_first_name_executive',
    'field_upcoming_lesson',
    'field_notes',
  ];

  override ngOnInit() {
    // Initialize pagination values
    this.paginationIndex = 0;
    this.pageSize = 10;  // Set default page size

    // Call parent ngOnInit if it exists
    super.ngOnInit();

    // Initial data load with pagination parameters
    this.getData([
      { parameter: 'page', value: this.paginationIndex.toString() },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ]);
  }

  override getData(params: { parameter: string; value: string; }[]) {
    this.ShowProgressBar = true;

    // Store only non-pagination params in queryParams
    this.queryParams = params.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Add current pagination state to params if not present
    let finalParams = [...params];
    if (!params.some(p => p.parameter === 'page')) {
      finalParams.push(
        { parameter: 'page', value: this.paginationIndex.toString() },
        { parameter: 'items_per_page', value: this.pageSize.toString() }
      );
    }

    // Add sorting parameters if available
    if (this.sortParams !== undefined) {
      finalParams.push(this.sortParams);
    }

    // Alter start_date and end_date params for Drupal.
    let start_date;
    let end_date;
    let field_sale_date;

    if (finalParams) {
      for (const property in finalParams) {
        if (finalParams[property]?.['parameter'] == 'start_date') {
          start_date = this.reportDateService.formatCalendarParam(finalParams[property]?.['value']);
        }
        if (finalParams[property]?.['parameter'] == 'end_date') {
          end_date = this.reportDateService.formatCalendarParam(finalParams[property]?.['value']);
        }
      }

      field_sale_date = {
        parameter: 'field_sale_date',
        value: start_date + "--" + end_date,
      }
    }

    if (field_sale_date && field_sale_date?.['value'] != 'undefined--undefined')  {
      finalParams = [
        ...finalParams,
        field_sale_date
      ];
    }

    // Load the new data with the filtering parameters.
    let endpoint: string = "/api/v1/enrollment-tracker";

    this._drupalRESTService.httpGET(endpoint, finalParams)
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;

        this.data = data;
        this.dataSource = new MatTableDataSource(data['results']);

        // Pagination
        if (data['results']) {
          this.setupPagination(data, params);
        }
      },
        error => this.handleError(error)
      )
  }

  override resetForm() {
    // Clear all stored params
    this.queryParams = [];
    this.sortParams = undefined;

    // Reset pagination
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginationIndex = 0;  // Reset the pagination index
      this.pageSize = 10;  // Reset page size
    }

    // Clear the form
    this.form.resetForm();

    // Make a fresh request with explicitly empty params
    this.getData([
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: '10' }
    ]);

    // Update router last
    this.updateRouterParams({});
  }

  override pageChanged(event: PageEvent) {
    // Update pagination state
    this.paginationIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    // Always include pagination parameters
    const paginationParams: HttpParameter[] = [
      { parameter: 'page', value: this.paginationIndex.toString() },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ];

    // Filter out any existing pagination params from queryParams
    const filteredQueryParams = this.queryParams.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Combine filtered query params with new pagination params
    const combinedParams = [...filteredQueryParams, ...paginationParams];
    this.getData(combinedParams);
  }

  override onPageSizeOptions() {
    return [10, 25, 50, 100, 250];
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }
    // DO NOT call updateRouterParams here - prevents duplicate requests
  }
}
